import { NextPage } from 'next'
import { MetaTags } from '~shared'
import { Grid, Layout } from '~ui'
import Tickets from 'components/tickets'
import StarsNearYou from 'components/tickets/near-you-stars'
import { addApolloState, initializeApollo } from '~services/apollo'
import { AllSubCategoriesForStarsQuery } from 'gql'
import { categoriesProps } from 'components/navigation/filters-container'
import Categories from 'components/home/block/categories'
import CategoryEventsSlider from 'components/tickets/category-slider'
import { GET_ALL_CATEGORIES_QUERY } from 'gql/queries'
import { RowCategories } from './search'

export const getServerSideProps = async () => {
  const apollo = initializeApollo()

  const { data } = await apollo.query<AllSubCategoriesForStarsQuery>({
    query: GET_ALL_CATEGORIES_QUERY,
    variables: {
      categoryId: process.env.NEXT_PUBLIC_SPORTS_CATEGORY,
    },
  })

  const getSubCategories = (array) =>
    array &&
    array.length &&
    array.map(({ node: { id, name, starcategorySet } }) => ({
      id,
      name,
      categories: starcategorySet.edges.length ? getSubCategories(starcategorySet.edges) : [],
    }))

  const categoriesRaw = getSubCategories(data?.allCategories?.edges)
  const categories =
    data?.allCategories?.edges.map(({ node: { id, name } }) => ({ value: id, label: name })) || []

  return addApolloState(apollo, {
    props: { categories, categoriesRaw },
  })
}

const SportsTicketsPage: NextPage<{
  categories: categoriesProps[]
  categoriesRaw: RowCategories[]
}> = ({ categories, categoriesRaw }) => (
  <Layout>
    <MetaTags title="Sport tickets" />
    <Layout.Banner />
    <Layout.HomeHeader />
    <Layout.Main withPadding={false} withSidebar={false} backgroundColor="black">
      <Grid gap="80px" paddingBottom="80px">
        <Tickets
          backgroundImage="linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.7)), url(https://img.granted.co/1656083477106-sports-tickets.png)"
          title="sports tickets"
          color="red"
          icon="cup-red"
          description="Win or lose, we’re here for the hotdogs. Choose your favorite event or search for it above."
        />

        <Categories pages={['Sport']} />

        <StarsNearYou title="GAMES near" categoryId={process.env.NEXT_PUBLIC_SPORTS_CATEGORY} />

        {categories?.length
          ? categories.map((cat) => (
              <CategoryEventsSlider
                categoriesRaw={categoriesRaw}
                key={cat.value}
                title={cat.label}
                mainCategory={cat.value}
              />
            ))
          : null}
      </Grid>
    </Layout.Main>
    <Layout.Footer />
  </Layout>
)
export default SportsTicketsPage
